export default {
  descuentosArray: [],
  tiposDescuentosSelect: [
    {
      value: 'carrito',
      text: 'En el carrito final'
    },
    {
      value: 'negocio',
      text: 'Todo el negocio'
    },
    {
      value: 'restaurante',
      text: 'Restaurante'
    },
    {
      value: 'totem',
      text: 'Totem'
    },
    {
      value: 'categoria',
      text: 'Categoria'
    },
    {
      value: 'producto',
      text: 'Producto'
    },
    {
      value: 'productorest',
      text: 'Producto del restaurante'
    },
  ],
  modalidadDescuentosSelect: [
    {
      value: 'porcentaje',
      text: 'Porcentaje'
    },
    {
      value: 'absoluto',
      text: 'Valor Absoluto'
    },
    {
      value: 'promocion',
      text: 'Promoción'
    },
  ],
  promocionSelect: [
    {
      value: '2x1',
      text: '2x1'
    },
    {
      value: '3x1',
      text: '3x1'
    }
  ],
  restriccionModo: [
    {
      value: 'onl-domicilio',
      text: 'Online domicilio'
    },
    {
      value: 'onl-recoger',
      text: 'Online recoger'
    },
    {
      value: 'tpv-domicilio',
      text: 'TPV Domicilio'
    },
    {
      value: 'tpv-recoger',
      text: 'TPV recoger'
    },
    {
      value: 'carta',
      text: 'Carta'
    },
    {
      value: 'totem',
      text: 'Tótem'
    }
  ],
  tiposCondicionesSelect: [
    {
      value: 'totalMayor',
      text: 'Mayor que',
      tipos: ['carrito']
    },
  ],
  porcentajesSelect: [
    { value: 0.05, text: '5%' },
    { value: 0.1, text: '10%' },
    { value: 0.15, text: '15%' },
    { value: 0.2, text: '20%' },
    { value: 0.25, text: '25%' },
    { value: 0.3, text: '30%' },
    { value: 0.35, text: '35%' },
    { value: 0.4, text: '40%' },
    { value: 0.45, text: '45%' },
    { value: 0.5, text: '50%' },
  ]
}